import React from "react";
import { EstimateGradePrevalence, RegionalPrevalenceEstimate } from "types";
import { LanguageType } from "types";
import {Button, Divider} from 'semantic-ui-react'
import Translate, { getCountryName } from 'utils/translate/translateService';

function row(title: string, content: JSX.Element | string | string[] | null | undefined) {
    return (
        <div className={"d-flex justify-content-between mb-2"}>
            <div className={"country-popup-heading"}>
                {title}
            </div>
            <div className={"country-popup-text"}>
                {content}
            </div>
        </div>
    )
}

const createPopupGeographySection = (regionalEstimate: RegionalPrevalenceEstimate, title: string) => {
  const minString = `${(regionalEstimate.minEstimate * 100).toFixed(2)}%`
  const maxString = `${(regionalEstimate.maxEstimate * 100).toFixed(2)}%`
  const regionString = minString === maxString ? minString : `${minString} - ${maxString}`;

  return (
    <div key={Math.random()}>
        <div key={Math.random()} className="country-popup-header pt-1 mb-2">
            {title}
        </div>
        {row(Translate('EstimateRange'), (<b>{regionString}</b>))}
        {row(Translate('NumberEstimates'), (<b>{regionalEstimate.numEstimates}</b>))}
    </div>
  )
}

const CountryPopup = (country : any, language : LanguageType, estimateGradePrevalences: EstimateGradePrevalence[] | undefined, onDetailsClick?: any) => {
  const properties = estimateGradePrevalences?.find((prevalence) => 
    country &&
    country.properties &&
    country.properties.ISO_3_CODE &&
    prevalence.alpha3Code === country.properties.ISO_3_CODE
  );

  if (properties && properties.testsAdministered) {
    const regions: Array<any> = []
    let addRegion = (r: RegionalPrevalenceEstimate, name: string) => { 
      return (r !== undefined && r.numEstimates !== 0 ? regions.push({Region: r, Name: name}) : null) 
    }
    if(properties.nationalEstimate) {
      addRegion(properties.nationalEstimate, Translate('NationalEstimates'));
    }
    if(properties.regionalEstimate) {
      addRegion(properties.regionalEstimate, Translate('RegionalEstimates'));
    }
    if(properties.localEstimate) {
      addRegion(properties.localEstimate, Translate('LocalEstimates'));
    }
    if(properties.sublocalEstimate) {
      addRegion(properties.sublocalEstimate, Translate('SublocalEstimates'));
    }

    return (
      <div className="country-popup-content p-4" >
        <div className="country-popup-title">
            {getCountryName(properties.geographicalName, language, "CountryOptions")}
        </div>
          <Divider />
        {row(Translate("TestsAdministered"), <b>{properties.testsAdministered}</b>)}
        {row(Translate('NumSeroprevalenceEstimates'), <b>{properties.numberOfStudies}</b>)}
        {regions.map((o) => createPopupGeographySection(o.Region, o.Name))}
        {onDetailsClick ? 
            <Button className="not-found-button mt-2" onClick={()=>{ onDetailsClick()}}>
              {Translate("ViewPartnership")}
            </Button> : ""
        }
      </div>
    );
  }

  return (
    <div className="country-popup-content">
      <div className="country-popup-title">{getCountryName(properties?.geographicalName ?? '', language, "CountryOptions")}</div>
      <div className="col-12 p-0 flex country-popup-text">{Translate('NoData')}</div>
    </div>)
}

export default CountryPopup;